module.exports = __webpack_public_path__ + "static/img/14000470.7f861b32.png";